import React, { useState } from "react";
import Alert from "../../../controls/Alert";
import __ from "lodash";

const SplitHandlingOrderValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  const {lines, selectedLines} = record;

  const selectedCount = __.without(selectedLines, false ).length;
  if (selectedCount === 0) {
    error = true;
    errorMessage = "You must select at least one flight";
  }
  if (!error && selectedCount === lines.length) {
    error = true;
    errorMessage = "You cant select all the flights";
  }  

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default SplitHandlingOrderValidator;
